// Format: YYYY-MM-DD HH:mm:ss
export function getCurrentDateTime() {
    const now = new Date();

    const pad = (n) => n.toString().padStart(2, '0');
    const nowLocal = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ` +
        `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

    return nowLocal
}